import SoundResourceOptions from '../../../../domain/value_objects/resource_options/SoundResourceOptions';

export interface SoundResourceOptionsData {}

export default class SoundResourceOptionsMapper {
  public map(obj: SoundResourceOptionsData): SoundResourceOptions {
    return new SoundResourceOptions();
  }
}
